<template>
  <div>
    <Navigation></Navigation>
    <WarehouseCheck></WarehouseCheck>
  </div>
</template>

<script>
import WarehouseCheck from "../components/WarehouseCheck";
import Navigation from "../components/Navigation";

export default {
  name: "Warehouse",
  components: {
    WarehouseCheck,
    Navigation
  }
}
</script>

<style scoped>

</style>